import { render, staticRenderFns } from "./AdminEmDashboard.vue?vue&type=template&id=4c340434"
import script from "./AdminEmDashboard.vue?vue&type=script&lang=js"
export * from "./AdminEmDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports